module.exports = __webpack_public_path__ + "img/gisoon-logo.404decbb.jpg";